import classNames from 'classnames'
import styles from './RangeInput.module.css'
import { type RangeInputProps } from './types'
import { forwardRef } from 'react'

const RangeInput = forwardRef<HTMLInputElement, RangeInputProps>(function RangeInput(
  { className, fullWidth, ...props }: RangeInputProps,
  ref
) {
  return (
    <input
      ref={ref}
      {...props}
      className={classNames(styles.rangeInput, className, {
        ['fullWidth']: fullWidth && fullWidth !== 'mobile-only',
        ['fullWidthOnMobile']: fullWidth && fullWidth === 'mobile-only',
      })}
      type="range"
    />
  )
})

export default RangeInput
